import constants from "../constants";

const utils = {

    sortDivisions: (divisions) => {
        return divisions.sort((a, b) => {
            // TODO what happens if they're equal? SHOULD never happen
            return a[constants.divisionName] > b[constants.divisionName] ? 1 : -1;
        })
    },

    capitalize: (str) => {
        const newstr = str[0].toUpperCase();
        return newstr + str.slice(1);
    },
    
    randomColor: () => {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },

    getBaseUrl: (league) => {
        switch (league) {
            case constants.pages.localLeagues:
                return constants.uri.local + constants.uri.base;
            case constants.pages.genderLeagues:
                return constants.uri.gender + constants.uri.base;
            default:
                return constants.uri.base;
        }
    },

    getLineupTemplate: (players) => {
        const homeMaleCount = [
            players.homeMalePlayer1,
            players.homeMalePlayer2,
            players.homeMalePlayer3,
            players.homeMalePlayer4,
            players.homeMalePlayer5,
        ].filter(Boolean).length;

        const homeFemaleCount = [
            players.homeFemalePlayer1,
            players.homeFemalePlayer2,
            players.homeFemalePlayer3,
            players.homeFemalePlayer4,
            players.homeFemalePlayer5,
        ].filter(Boolean).length;

        const awayMaleCount = [
            players.awayMalePlayer1,
            players.awayMalePlayer2,
            players.awayMalePlayer3,
            players.awayMalePlayer4,
            players.awayMalePlayer5,
        ].filter(Boolean).length;

        const awayFemaleCount = [
            players.awayFemalePlayer1,
            players.awayFemalePlayer2,
            players.awayFemalePlayer3,
            players.awayFemalePlayer4,
            players.awayFemalePlayer5,
        ].filter(Boolean).length;

        return `${homeMaleCount}-${homeFemaleCount}_vs_${awayMaleCount}-${awayFemaleCount}`;
    },

    getPlayerStatusIcon: (p) => {
        const STATUS_ICON_MAP = [
            { check: (p) => p.isCaptain, src: '/icons/captain-yellow.svg', alt: 'Captain' },
            { check: (p) => p.isSub && p.subCount >= 2, src: '/icons/sub-red.svg', alt: 'Flagged Sub' },
            { check: (p) => p.isSub && (p.subCount ?? 0) < 2, src: '/icons/sub-green.svg', alt: 'Sub' },
        ];

        const match = STATUS_ICON_MAP.find(({ check }) => check(p));

        return (
            <>
                {match && <img src={match.src} alt={match.alt} style={{height:'24px', width: '24px'}} />}
                {p.isFlagged && <img src="/icons/flag-red.svg" alt="Flagged" style={{height:'24px', width: '24px'}} />}
            </>
        );
    }
}

function resolveRefs(obj, root = obj, map = {}) {
    if (obj && typeof obj === 'object') {
        if (obj.$ref) return map[obj.$ref];
        if (obj.$id) map[obj.$id] = obj;
        for (const key in obj) obj[key] = resolveRefs(obj[key], root, map);
    }
    return obj;
}

export default utils;
